import { createSelector } from 'reselect'

const getGameState = state => state.gameState

const getBattleResult = createSelector(
    getGameState,
    (gameState) => {
        const { battleResult } = gameState
        return battleResult
    }
)

export default getBattleResult
